/**
 * Build-time feature gates.
 *
 * Vite bakes VITE_* values into the bundle at build time (Dockerfile ARG →
 * azure.yaml buildArgs → the azd environment), so an environment that does not
 * set a flag ships without the feature. Read at render time, not at module
 * load, so tests can flip a flag with vi.stubEnv without re-importing modules.
 */

/** My Documents (employee document store). Needs the integration service's
 *  documents API in the same environment — PROD does not have it yet. */
export function documentsEnabled(): boolean {
  return import.meta.env.VITE_DOCUMENTS_ENABLED === 'true'
}

/** Hire requests raised by line managers. Needs identity's
 *  HIRE_REQUESTS_ENABLED in the same environment — UAT first, not PROD. */
export function hireRequestsEnabled(): boolean {
  return import.meta.env.VITE_HIRE_REQUESTS_ENABLED === 'true'
}

/** Termination requests (resignations, and those a People Leader raises).
 *  Needs identity's TERMINATION_REQUESTS_ENABLED, and the documents store for
 *  the letter: never on without VITE_DOCUMENTS_ENABLED. UAT first, not PROD. */
export function terminationRequestsEnabled(): boolean {
  return import.meta.env.VITE_TERMINATION_REQUESTS_ENABLED === 'true' && documentsEnabled()
}
